export default __webpack_public_path__ + "static/media/cummulativeExam.6d7b7f38.png";